module.exports = __webpack_public_path__ + "img/stock7.2713a20a.png";